import { HelpCircle, BookOpen, MessageSquare, Zap } from "lucide-react";

const COMMANDS = [
  { cmd: "/play <query>", desc: "Search & play a song or YouTube link" },
  { cmd: "/pause", desc: "Pause the current track" },
  { cmd: "/resume", desc: "Resume playback" },
  { cmd: "/skip", desc: "Skip to the next track" },
  { cmd: "/stop", desc: "Stop and clear the queue" },
  { cmd: "/queue", desc: "Show the current queue" },
  { cmd: "/panel", desc: "Open the music control panel" },
  { cmd: "/ping", desc: "Check if the bot is alive" },
];

export default function HelpPanel() {
  return (
    <div data-testid="help-panel" className="space-y-8 max-w-4xl">
      <div>
        <div className="overline mb-2"><HelpCircle className="inline w-4 h-4 mr-2 -mt-1" />UTILITIES</div>
        <h1 className="font-heading text-4xl font-bold uppercase tracking-tight">Help & Documentation</h1>
        <p className="text-zinc-400 mt-2">Quick reference for commands, features, and how to get the most out of 606 Bot.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[
          { icon: BookOpen, title: "Getting Started", text: "Click 'Add Bot to Server' on the home page. Then assign your manage-server roles to control it from this dashboard." },
          { icon: MessageSquare, title: "Bot Personality", text: "Customize nickname, status, and brand color in Bot Personalizer. Each server has independent settings." },
          { icon: Zap, title: "Slash Commands", text: "Type / in any channel and Discord auto-suggests commands. The bot syncs them on join." },
        ].map((c) => {
          const Icon = c.icon;
          return (
            <div key={c.title} className="tactical-card p-5">
              <Icon className="w-5 h-5 text-brand-orange mb-3" />
              <h3 className="font-heading uppercase text-base font-bold tracking-tight mb-2">{c.title}</h3>
              <p className="text-sm text-zinc-400">{c.text}</p>
            </div>
          );
        })}
      </div>

      <div className="tactical-card p-6">
        <h2 className="font-heading text-xl uppercase mb-5">All Commands</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {COMMANDS.map((c) => (
            <div key={c.cmd} className="border border-brand-line p-3 rounded-lg flex items-start gap-3">
              <code className="text-brand-orange font-mono-tabular text-sm shrink-0 mt-0.5">{c.cmd}</code>
              <div className="text-sm text-zinc-300">{c.desc}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="tactical-card p-6">
        <h2 className="font-heading text-xl uppercase mb-3">Need help?</h2>
        <p className="text-zinc-400 text-sm mb-4">
          Found a bug or have a feature request? The fastest way to reach us is the support channel in the 606 Community Discord.
        </p>
        <div className="flex gap-3">
          <a href="https://discord.com" target="_blank" rel="noreferrer" className="btn-primary">Join Support</a>
          <a href="#" className="btn-secondary">Documentation</a>
        </div>
      </div>
    </div>
  );
}
